import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateProductCategoryName = () => {
  return useMutation({
    mutationFn: updateProductCategory,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.viewProductCategoriesWithProducts.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.productCategories.invalidateAll(),
      );
    },
  });
};

const updateProductCategory = async (payload: {
  categoryId: string;
  categoryName: string;
}) => {
  const request = {
    name: payload.categoryName,
  };

  const response = await requestCCApi({
    url: `/productCategories/${payload.categoryId}`,
    method: 'PUT',
    data: { data: request },
  });

  return response;
};
